module.exports = __webpack_public_path__ + "static/media/redBall2.8101889f.png";